import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

const useGuidedHighlightingFeedbackGet = () => {
  const createEventRecordRequest = useCallback(
    (params: { questionsIdList: string }) => {
      const questionsIdList = params.questionsIdList;
      const requestUrl = `${MONOLITH_ORIGIN}/api/v3/guided-highlighting/report-questions/${questionsIdList}`;
      const requestConfig = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      };
      return new Request(requestUrl, requestConfig);
    },
    [],
  );
  return useRestMutation(createEventRecordRequest);
};

export default useGuidedHighlightingFeedbackGet;
